import React from "react";
import './home.css';



const Home = () => {
return(
    <>
    <div className="home-page">
        <div className="home-div">
            <p className="pt-5"> WELCOME</p>
            <h1> To the CURD Opeartion Website</h1>
        </div>
    </div>
    </>
)

}

export default Home;
